/* ******************** NPM ******************** */
// Use following imports only where needed (not globally)
// Bootstrap modules (add as needed)
import "bootstrap/js/dist/modal";
import "bootstrap/js/dist/carousel";
import "bootstrap/js/dist/collapse";

/* ******************** BASE ******************** */
// Import utilities as needed
import {
    utl_keyboardFocusMode,
    utl_setFooterYear,
    utl_handleModalClose,
    utl_ehElements,
    utl_anchorScrollOffset,
    // utl_toggleCookiesAlert,
} from "./base/_utils.js";

// Call utility functions after imported
utl_keyboardFocusMode();
utl_setFooterYear();
utl_handleModalClose;
utl_anchorScrollOffset();
// utl_toggleCookiesAlert();
document.querySelector(".eh-container") && utl_ehElements();

/* ******************** COMPONENTS ******************** */

import navigationInit from "./components/_navigation.js";
import carouselsInit from "./components/_carousels";
import stickySidesInit from "./components/_sticky-sides";
import edgeLineInit from "./components/_edge-line.js";
import gsapDataTrigger from "./components/_gsap-data-trigger.js";

navigationInit();
carouselsInit();
stickySidesInit();
edgeLineInit();
gsapDataTrigger();

/* ******************** PAGES ******************** */
// Individual page scripts are added in the header of specific page's index file
